import rest from 'Services/restFootData';
import { SubmissionError } from 'redux-form';
import qs from 'query-string';

export function fetchCoaches(search) {
  const params = {
    itemsPerPage: 10,
    ...qs.parse(search),
    role: 'coach',
    partial: 0,
    'order[translations.priority]': 'asc',
    groups: ['read', '_image', '_club'],
  };
  return function(dispatch) {
    dispatch({ type: 'FETCH_COACHES' });

    return rest
      .get('people/with_club/', { params })
      .then(
        res => dispatch({ type: 'FETCH_COACHES_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_COACHES_REJECTED', payload: err.response })
      );
  };
}

export function fetchCoach(slug) {
  const params = {
    slug,
    role: 'coach',
    groups: ['read', '_image', '_meta'],
  };

  return function(dispatch) {
    dispatch({ type: 'FETCH_COACH' });

    return rest.get('people', { params }).then(
      res => {
        if (res.data.collection && res.data.collection[0]) {
          return dispatch({
            type: 'FETCH_COACH_FULFILLED',
            payload: res.data.collection[0],
          });
        }
        return dispatch({ type: 'FETCH_COACH_NOTFOUND' });
      },
      err => dispatch({ type: 'FETCH_COACH_REJECTED', payload: err.response })
    );
  };
}

export function fetchCoachById(id) {
  return function(dispatch) {
    dispatch({ type: 'FETCH_COACH' });

    return rest
      .get(`people/${id}}`)
      .then(
        res => dispatch({ type: 'FETCH_COACH_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_COACH_REJECTED', payload: err.response })
      );
  };
}

export function updateCoach(id, coach) {
  const params = {
    groups: ['read', '_image', '_meta'],
  };

  return function(dispatch) {
    dispatch({ type: 'UPDATE_COACH', payload: id });
    return rest.put(`people/${id}`, coach, { params }).then(
      res => {
        dispatch({
          type: 'ADD_NOTIFICATION',
          payload: { messageKey: 'message_coachUpdated', type: 'success' },
        });
        return dispatch({ type: 'UPDATE_COACH_FULFILLED', payload: res.data });
      },
      err => {
        if (err.response && err.response.data.type === 'ConstraintViolationList') {
          const { errors } = err.response.data;
          throw new SubmissionError(errors);
        }
        return dispatch({
          type: 'UPDATE_COACH_REJECTED',
          payload: err.response,
        });
      }
    );
  };
}

export function addCoach(coach) {
  return function(dispatch) {
    dispatch({ type: 'ADD_COACH' });

    return rest
      .post('people', coach)
      .then(
        res => dispatch({ type: 'ADD_COACH_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'ADD_COACH_REJECTED', payload: err.response })
      );
  };
}

export function deleteCoach(id) {
  return function(dispatch) {
    dispatch({ type: 'DELETE_COACH', payload: id });

    return rest
      .delete(`people/${id}`)
      .then(
        () => dispatch({ type: 'DELETE_COACH_FULFILLED', payload: { id } }),
        err => dispatch({ type: 'DELETE_COACH_REJECTED', payload: err.response })
      );
  };
}
